/* Native <dialog> opener: [data-uc-dialog-open="id"] opens, [data-uc-dialog-close] or a
   backdrop click closes, Esc is handled by the browser. Focus returns to the opener. */
(() => {
  if (window.__ucDialogReady) return;
  window.__ucDialogReady = true;

  /** @type {HTMLElement|null} */
  let opener = null;

  const open = (dialog, from) => {
    if (!dialog || typeof dialog.showModal !== 'function') return;
    opener = from;
    dialog.showModal();
    document.documentElement.classList.add('uc-dialog-open');
    const close = dialog.querySelector('[data-uc-dialog-close]');
    if (close) close.focus();
  };

  document.addEventListener('click', (event) => {
    const target = event.target instanceof Element ? event.target : null;
    if (!target) return;
    const trigger = target.closest('[data-uc-dialog-open]');
    if (trigger) {
      event.preventDefault();
      open(document.getElementById(trigger.getAttribute('data-uc-dialog-open')), trigger);
      return;
    }
    const closer = target.closest('[data-uc-dialog-close]');
    if (closer) {
      const dialog = closer.closest('dialog');
      if (dialog) dialog.close();
      return;
    }
    if (target instanceof HTMLDialogElement && target.open) {
      const box = target.getBoundingClientRect();
      const inside = event.clientX >= box.left && event.clientX <= box.right && event.clientY >= box.top && event.clientY <= box.bottom;
      if (!inside) target.close();
    }
  });

  document.addEventListener('close', (event) => {
    if (!(event.target instanceof HTMLDialogElement)) return;
    document.documentElement.classList.remove('uc-dialog-open');
    if (opener && document.contains(opener)) opener.focus();
    opener = null;
  }, true);
})();
